import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    options: { customProperties: true },
    themes: {
      dark: {
        primary: '#029cf0'
      }
    }
  }
});
